/** Kullanıcı bazında seçilebilen arayüz tasarımları (sunucu: server/src/system/tercih.ts TASARIMLAR) */
export type DesignId = 'aurora' | 'obsidian' | 'ledger' | 'atelier' | 'pitstop';
export type Mode = 'acik' | 'koyu' | 'sistem';
export type Density = 'rahat' | 'normal' | 'sik';
/** sidebar: sol menü · rail: ikon rayı + açılır panel · topnav: üst menü */
export type Layout = 'sidebar' | 'rail' | 'topnav';

export interface DesignDef {
  id: DesignId;
  no: number;
  ad: string;
  ozet: string;
  layout: Layout;
  /** Yazı tipleri (yerel paketlerden, isteğe bağlı yüklenir) */
  fonts: () => Promise<unknown>[];
  /** Önizleme renkleri */
  renkler: string[];
  /** Kullanıcı "Sistem" seçtiğinde bile önerilen mod (Obsidian koyu doğmuştur) */
  dogalMod: 'acik' | 'koyu';
}

export const DESIGNS: DesignDef[] = [
  {
    id: 'aurora', no: 1, ad: 'Aurora', layout: 'sidebar', dogalMod: 'acik',
    ozet: 'Ferah, mor-indigo degrade vurgular, buzlu cam kartlar, yuvarlak hatlar.',
    renkler: ['#6366f1', '#a855f7', '#ec4899', '#f6f7fb'],
    fonts: () => [import('@fontsource-variable/plus-jakarta-sans'), import('@fontsource-variable/jetbrains-mono')],
  },
  {
    id: 'obsidian', no: 2, ad: 'Obsidian', layout: 'rail', dogalMod: 'koyu',
    ozet: 'Koyu ve keskin; zümrüt/camgöbeği vurgular, ikon rayı, komut paleti odaklı.',
    renkler: ['#09090b', '#10b981', '#22d3ee', '#27272a'],
    fonts: () => [import('@fontsource-variable/geist'), import('@fontsource-variable/geist-mono')],
  },
  {
    id: 'ledger', no: 3, ad: 'Ledger', layout: 'topnav', dogalMod: 'acik',
    ozet: 'Kurumsal; üst menü, yoğun tablolar, mavi vurgu. Finans paneli disiplini.',
    renkler: ['#ffffff', '#2563eb', '#0f172a', '#e2e8f0'],
    fonts: () => [import('@fontsource-variable/inter'), import('@fontsource-variable/jetbrains-mono')],
  },
  {
    id: 'atelier', no: 4, ad: 'Atelier', layout: 'sidebar', dogalMod: 'acik',
    ozet: 'Sıcak krem zemin, kiremit turuncusu, serif başlıklar, yumuşak kartlar.',
    renkler: ['#faf7f2', '#ea580c', '#292524', '#a8a29e'],
    fonts: () => [import('@fontsource-variable/dm-sans'), import('@fontsource-variable/fraunces'), import('@fontsource-variable/jetbrains-mono')],
  },
  {
    id: 'pitstop', no: 5, ad: 'Pitstop', layout: 'sidebar', dogalMod: 'acik',
    ozet: 'Otomotiv kokpiti; koyu menü, kırmızı-amber vurgu, kalın büyük harf başlıklar.',
    renkler: ['#0b0f17', '#ef4444', '#f59e0b', '#f1f5f9'],
    fonts: () => [import('@fontsource-variable/space-grotesk'), import('@fontsource-variable/jetbrains-mono')],
  },
];

export const designOf = (id: string | null | undefined): DesignDef => DESIGNS.find((d) => d.id === id) ?? DESIGNS[0];
